// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2024-09-17 16:17:04 +0200 (Tue, 17 Sep 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 145849 $
//  Purpose   : gndo parts
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Icon} from 'semantic-ui-react'

// ---Framework imports
import {dict, mapItems} from 'ldash'
import {Sel} from 'uix/registries'
import log from 'uix/logging'
import {HeaderSegment, Editor, XMenu} from 'uix/components'
import {MIME, formatDateTime} from 'uix/utils'
import {JobMenuButton} from 'uix/job/components'
import {useApi, usePhysicalNode, useResettableState, useCallApi} from 'uix/hooks'

import {loadLazy, funcPart} from 'uix/parts'

// ---Exports

// ---Globals
export const GndoResource = ({}) => {
  let node = usePhysicalNode()
  let {data, error, loading, reload} = useApi(
    'gndo/getCode',
    {
      otid: node.otid,
      datatypeName: node.datatypeName,
    },
    {autoreset: false}
  )
  let [text, setText] = useResettableState(null, [data, node])
  if (text === null) {
    text = data?.gndo
  }
  let {callApi, calling} = useCallApi('gndo/saveCode')
  let modified = text !== null && text !== data?.gndo
  let save = () => callApi({otid: node.otid, text}, reload)

  let menu = (
    <XMenu>
      <XMenu.Item icon="save" disabled={!modified} onClick={save} />
      <JobMenuButton name="GndUpdate" label="Update" params={{ids: [node.otid]}} />
    </XMenu>
  )
  let subheader = formatDateTime(data?.updatets)
  return (
    <HeaderSegment
      icon="file outline"
      header="GNDO"
      subheader={subheader}
      flex
      menu={menu}
      loading={loading || calling}
    >
      <Editor
        flex
        mimetype={MIME.XML}
        text={text}
        extraKeys={{'Ctrl-S': save}}
        onBeforeChange={({value}) => setText(value)}
      />
    </HeaderSegment>
  )
}

export const GndoResourceLobId = ({}) => {
  let node = usePhysicalNode()
  let {data, error, loading} = useApi('gndo/getLiveInfo', {
    otid: node.otid,
  })
  let text = JSON.stringify(data?.gndo, null, 2)
  return (
    <HeaderSegment icon="file outline" header="GNDO" flex>
      <Editor flex mimetype={MIME.JSONLD} text={text} />
    </HeaderSegment>
  )
}

export const GndoForcegraph = loadLazy(() => import(/* webpackChunkName: 'gndo' */ './graph'))
export const GndoMap = loadLazy(() => import(/* webpackChunkName: 'gndo_map' */ './map'))
